<template>
    <div
        :key="locale"
        v-if="pageOptions.pageEmpty"
        v-bind:class="{ 'page-content-full-height': pageOptions.pageContentFullHeight }"
    >
        <div
            class="content-full"
            style=""
            v-bind:class="{
                'content-full-width': pageOptions.pageContentFullWidth,
                'content-inverse-mode': pageOptions.pageContentInverseMode,
            }"
        >
            <router-view></router-view>
        </div>
    </div>

    <div
        v-else
        :key="locale"
        :class="[
            'fade',
            'page-sidebar-fixed',
            'show',
            'page-container',
            {
                'page-header-fixed': !isMobile,
                'page-sidebar-minified': pageOptions.pageSidebarMinified,
                'page-content-full-height': pageOptions.pageContentFullHeight,
                'page-without-sidebar': pageOptions.pageWithoutSidebar,
                'page-with-right-sidebar': pageOptions.pageWithRightSidebar,
                'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
                'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
                'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
                'page-with-top-menu': pageOptions.pageWithTopMenu,
                'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
                'page-right-sidebar-toggled':
                    pageOptions.pageMobileRightSidebarToggled || pageOptions.pageRightSidebarToggled,
                'page-right-sidebar-collapsed': pageOptions.pageRightSidebarCollapsed,
                'has-scroll': pageOptions.pageBodyScrollTop,
            },
        ]"
        v-bind:style="contentFontColor"
    >
        <!-- HEMS(/hems|/mobile)는 MobileAppShell 등 화면 자체 헤더 사용. MobileHeader 미사용. -->
        <Header v-if="!isMobile" />

        <TopMenu v-if="pageOptions.pageWithTopMenu" />
        <Sidebar v-if="!pageOptions.pageWithoutSidebar" />
        <SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
        <ToolBar />
        <!--  :style="{ backgroundColor: this.themeColor.backgroundColor} " -->
        <div class="content" v-bind:style="[contentBgColor, contentBackgroundImage, contentSidebarOffsetStyle]">
            <router-view></router-view>
        </div>

        <notifications
            class="noti-right"
            group="noti-right"
            position="top right"
            :max="5"
            :speed="500"
            :duration="5000"
        />
        <notifications
            class="noti-bottom"
            group="noti-bottom"
            position="bottom right"
            :max="5"
            :speed="500"
            :duration="5000"
        />

        <Footer v-if="pageOptions.pageWithFooter" />

        <!-- <button
            v-if="isAuthenticated && !isMobile && showAgentChatFab && !agentChatOpen"
            type="button"
            class="agent-chat-fab"
            aria-label="AI Agent"
            title="AI Agent"
            @click="agentChatOpen = true"
        >
            <i class="material-icons-outlined agent-chat-fab-icon" aria-hidden="true">smart_toy</i>
        </button>
        <AgentChatDrawer v-model="agentChatOpen" :route-path="$route.path" /> -->

        <globalTimerLogout></globalTimerLogout>
    </div>
</template>

<style scoped>
.content {
    padding: 15px 15px !important;
}

.agent-chat-fab {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 1020;
    width: 56px;
    height: 56px;
    padding: 0;
    border: none;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(180deg, #3b82f6 0%, #2563eb 48%, #1d4ed8 100%);
    transition:
        transform 0.12s ease,
        filter 0.12s ease;
}

.agent-chat-fab:hover {
    filter: brightness(1.05);
}

.agent-chat-fab:active {
    transform: translateY(2px);
}

.agent-chat-fab-icon {
    font-size: 28px;
    line-height: 1;
}
</style>

<script>
import Vue from "vue";
import { mapState } from "vuex";
//import PageOptions from "./config/PageOptions.vue";

// Old Style
// import Sidebar from "./components/sidebar/Sidebar.vue";
// import SidebarRight from "./components/sidebar-right/SidebarRight.vue";
// import Header from "./components/header/Header.vue";
// import TopMenu from "./components/top-menu/TopMenu.vue";
// import Footer from "./components/footer/Footer.vue";
// import ToolBar from "./components/tool-bar/ToolBar.vue";
// 원래 있던 progressBar 동작하지 않아서, axios-progress-bar를 추가함..
// import { loadProgressBar } from "axios-progress-bar";
// import "axios-progress-bar/dist/nprogress.css";

// New Style
import Sidebar from "@components/sidebar/Sidebar.vue";
import SidebarRight from "@components/sidebar/Sidebar.vue";
import Header from "@components/header/Header.vue";
import TopMenu from "@components/top-menu/TopMenu.vue";
import Footer from "@components/footer/Footer.vue";
import ToolBar from "@components/tool-bar/ToolBar.vue";
import { loadProgressBar } from "axios-progress-bar";
import "axios-progress-bar/dist/nprogress.css";
import globalTimerLogout from "@src/views/globalTimerLogout.vue";
// import AgentChatDrawer from "@components/agent/AgentChatDrawer.vue";

loadProgressBar();

//#region // ANDROID -- ANDROID -- ANDROID -- ANDROID ----------------------------------------------------------------------/

// TODO: 알람 상세 보기 페이지로 이동하기, 상세 페이지 작성 예정
let _APP = null;
function _goAndroidAlarm(alarmLogIdx) {
    if (_APP) {
        if (typeof alarmLogIdx != "undefined" && alarmLogIdx !== null)
            _APP.$router.push(`/alarm/alarmView/${alarmLogIdx}`);
    }
}
// android에서 호출
// myWebView.loadUrl("javascript:goAndroidAlarm('"+ alarmIdx +"')");

function _logoutByAndroid(loginUser, noRedirect) {
    if (_APP) {
        if (typeof loginUser != "undefined" && loginUser !== null)
            _APP.$store.dispatch("LOGOUT", loginUser).then(() => {
                console.log("안드로이드 웹뷰 로그아웃이 완료되었습니다.");

                if (noRedirect !== true)
                    setTimeout(() => {
                        _APP.$router.go("/");
                    }, 100);
            });
    }
}

/// 안드로이드에서 자바스크립트 함수를 호출하기 위해 글로벌 오브젝트로 만듬
/// https://javascript.info/global-object
window.android = {
    goAndroidAlarm: _goAndroidAlarm,
    logoutByAndroid: _logoutByAndroid,
};
// function makeGlobalObjectForAndroid(app) {
//   if (typeof Android !== 'undefined' && Android) {
//     _APP = app;
//
//     window.android = {
//       goAndroidAlarm: _goAndroidAlarm,
//       logoutByAndroid: _logoutByAndroid
//     };
//   }
// }
//#endregion // ANDROID -- ANDROID -- ANDROID -- ANDROID ----------------------------------------------------------------------/

export default {
    name: "app",
    components: {
        Sidebar,
        SidebarRight,
        Header,
        TopMenu,
        Footer,
        ToolBar,
        globalTimerLogout,
        // AgentChatDrawer,
    },
    data() {
        return {
            // pageOptions: PageOptions,
            agentChatOpen: false,
            contentBgColor: {
                backgroundColor: "#d9e0e7",
                fontColor: "#333",
            },
            contentFontColor: {
                color: "#333",
            },
            mouseStopTimer: null,
        };
    },
    computed: {
        ...mapState({
            isEditMode: (state) => state.isEditMode,
            widgetStyle: (state) => state.widgetStyle,
        }),
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        loginUser() {
            return this.$store.getters.loginUser;
        },
        locale() {
            return this.$store.getters.locale;
        },
        isMobile() {
            return global.xe.getTargetClient && global.xe.getTargetClient() === "Mobile";
        },
        showAgentChatFab() {
            const path = this.$route?.path || "";
            return !(global.xe.isHemsRoute && global.xe.isHemsRoute(path));
        },
        contentBackgroundImage() {
            const routeName = this.$route.name;
            if (routeName === "DataVisualization") {
                return {
                    backgroundImage: `url('${this.widgetStyle?.backgroundImage}')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "fixed",
                };
            } else {
                return {
                    backgroundColor: "rgb(217, 224, 231)",
                };
            }
        },
        /**
         * PC에서만 사이드바/편집 모드에 맞춰 content를 민다.
         * 좁은 화면(<1200)은 vue.scss 오버레이 규칙을 쓰므로 인라인 margin을 넣지 않는다.
         */
        contentSidebarOffsetStyle() {
            if (typeof window !== "undefined" && window.innerWidth < 1200) {
                return {};
            }
            if (this.pageOptions.pageMobileSidebarToggled || this.isEditMode) {
                return { marginLeft: "220px" };
            }
            return {};
        },
    },
    watch: {
        "$route.params": function () {
            this.isShowTab = true; // 메뉴를 눌러 location이 이동하면, 첫번째 tab 으로 이동시킨다.
        },
        $route: function () {
            this.onChangeMainPage();
        },
        // //"$store.getters.menus": function(){
        // "$store.getters.navs": function() {
        //   this.onChangeMainPage();
        // },
        isAuthenticated: {
            async handler(newVal) {
                if (newVal) {
                    // HEMS(/hems|/mobile): 입주민 화면은 resident API만 사용.
                    // PC CxEMS용 마스터·실시간·플러그인 부트스트랩은 스킵 (PC 경로는 기존 유지).
                    const isHems = global.xe.isHemsRoute(this.$route.path);
                    this.$store.dispatch("UPDATE_TOKEN");
                    this.$store.dispatch("UPDATE_MASTER");
                    this.$store.commit("RUN_AUTO_LOGOUT_TIMER");
                    this.$store.dispatch("UPDATE_LOGIN_INFO");
                    if (isHems) return;
                    this.$store.dispatch("CREATE_WEB_SOCKET");
                    this.$store.dispatch("UPDATE_PT_MAP");
                    // CommonCode Loading by badblock. 20240328
                    this.$store.dispatch("FETCH_UNIT_CODES");
                    // zoneInfo Loading by woonsik. 20240419
                    this.$store.dispatch("FETCH_ZONE_INFO");
                    this.$store.dispatch("FETCH_SYSTEM_TYPE_LIST");
                    this.$store.dispatch("FETCH_DRIVER_LIST");
                    this.$store.dispatch("FETCH_EQUIP_TYPE_LIST");
                    // made by woonsik, wooksik 20240823
                    this.$store.dispatch("FETCH_POINT_LIST");
                    this.$store.dispatch("FETCH_ACTIVE_PLUGINS");
                    await this.$store.dispatch("FETCH_COMMON_CODES");
                    await this.$store.dispatch("FETCH_POINTLIST_OPTIONS");
                } else {
                    const loginPath = global.xe.isHemsRoute(this.$route.path) ? "/hems/login" : "/login";
                    if (this.$route.path === loginPath) return;
                    // HEMS는 replace(히스토리·이중 네비 방지), PC는 기존 push 유지
                    const nav = loginPath === "/hems/login" ? this.$router.replace : this.$router.push;
                    nav.call(this.$router, loginPath).catch((err) => {
                        if (err && err.name !== "NavigationDuplicated") {
                            console.warn("login redirect failed", err);
                        }
                    });
                }
            },
            immediate: true,
        },
    },
    async created() {
        this.pageOptions.pageBodyScrollTop = window.scrollY;

        // 태블릿·모바일 웹 오버레이 구간: 첫 진입 시 사이드바를 접힌(아이콘) 상태로 시작
        this.ensureSidebarCollapsedForOverlay();

        this.$store.dispatch("UPDATE_MASTER_GROUP");
        // this.$store.dispatch("UPDATE_TOKEN");
        // this.$store.dispatch("UPDATE_MASTER");

        // this.$store.dispatch("CREATE_WEB_SOCKET");

        // this.$store.commit("RUN_AUTO_LOGOUT_TIMER");

        // //if (this.isAuthenticated) this.$store.commit("UPDATE_TARGET_CLIENT", this.isMobile ? "Mobile" : "PC");
        // //this.$store.dispatch("UPDATE_STRINGS"); // 리소스 문자열
        // //this.$store.dispatch("UPDATE_TRANS"); // DB 다국어 문자열
        // //if (this.isAuthenticated) this.$store.dispatch("UPDATE_MENUS");
        // this.$store.dispatch("UPDATE_LOGIN_INFO");

        // this.$store.dispatch("UPDATE_PT_MAP");

        // // CommonCode Loading by badblock. 20240328
        // this.$store.dispatch("FETCH_UNIT_CODES");

        // // zoneInfo Loading by woonsik. 20240419
        // this.$store.dispatch("FETCH_ZONE_INFO");

        // this.$store.dispatch("FETCH_SYSTEM_TYPE_LIST");
        // this.$store.dispatch("FETCH_DRIVER_LIST");
        // this.$store.dispatch("FETCH_EQUIP_TYPE_LIST");

        // // made by woonsik, wooksik 20240823
        // this.$store.dispatch("FETCH_POINT_LIST");

        // await this.$store.dispatch("FETCH_COMMON_CODES");
        // await this.$store.dispatch("FETCH_POINTLIST_OPTIONS");

        // resize시에 RightSideBar가 나타나는 오동작 해결된듯...
        if (!this.checkMobile()) this.pageOptions.pageRightSidebarToggled = !this.pageOptions.pageRightSidebarToggled; // pc 모드 시작시 숨기기

        // 마지막 scroll 위치를 복원한다.
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.ensureSidebarCollapsedForOverlay);
    },
    async mounted() {
        // console.log(" APP mounted APP mounted APP mounted APP mounted APP mounted APP mounted APP mounted ");
        _APP = this;
        // this.$insProgress.finish();

        this.onChangeMainPage(this.$route);

        // 로그인과 회원가입 페이지가 아니면 로그인정보가 있을때만 접근할 수 있다.
        const publicPaths = ["/login", "/register", "/hems/login"];
        if (!publicPaths.includes(this.$route.path)) {
            if (this.isEmpty(this.loginUser)) {
                // console.log("로그아웃하여 루트로 이동");
                const loginPath = global.xe.isHemsRoute(this.$route.path) ? "/hems/login" : "/login";
                if (this.$route.path !== loginPath) {
                    const nav = loginPath === "/hems/login" ? this.$router.replace : this.$router.push;
                    nav.call(this.$router, loginPath).catch((err) => {
                        if (err && err.name !== "NavigationDuplicated") {
                            console.warn("login redirect failed", err);
                        }
                    });
                }
            }
        }

        // 메뉴가 사라지면 다시 바인딩...
        setTimeout(() => {
            if (Object.keys(this.readStorage("menus")).length == 0) {
                if (this.isAuthenticated) this.$store.dispatch("UPDATE_MENUS");
            }
        }, 3000);

        // this.$store.commit("SET_AUTO_LOGOUT_STATE", true);
        // this.$store.dispatch("UPDATE_AUTO_LOGOUT_INTERVAL", time);

        // document.addEventListener("mousemove", () => {
        //     if (this.$store.getters.getAutoLogoutState === true) {
        //         this.$store.dispatch("UPDATE_AUTO_LOGOUT_STATE", false);
        //     }
        //     clearTimeout(this.mouseStopTimer);
        //     this.mouseStopTimer = setTimeout(this.mouseStopped, 1000);
        // });

        // document.addEventListener("keydown", () => {
        //     if (this.$store.getters.getAutoLogoutState === true) {
        //         this.$store.dispatch("UPDATE_AUTO_LOGOUT_STATE", false);
        //     }
        //     clearTimeout(this.mouseStopTimer);
        //     this.mouseStopTimer = setTimeout(this.mouseStopped, 1000);
        // });

        // TODO: AccessToken이나 loginUser정보가 없어졌으면,  루트로 이동해야 함.
        // this.$router.go("/");
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.ensureSidebarCollapsedForOverlay);
    },
    methods: {
        /**
         * 오버레이 구간(<1200): 최초 진입 또는 PC→좁은 화면 전환 시에만 사이드바를 접는다.
         * 이미 오버레이 구간에서 사용자가 펼친 상태는 유지한다.
         */
        ensureSidebarCollapsedForOverlay() {
            if (typeof window === "undefined") return;
            const isOverlay = window.innerWidth < 1200;
            if (isOverlay && this._lastViewportWasOverlay !== true) {
                this.pageOptions.pageSidebarMinified = true;
            }
            this._lastViewportWasOverlay = isOverlay;
        },
        mouseStopped() {
            let path = window.location.href.toLowerCase();
            const ignorePaths = ["dashboard", "login", "building-energy-efficiency-analysis"];
            // building-energy-efficiency-analysis
            if (ignorePaths.every((keyword) => !path.includes(keyword))) {
                this.$store.dispatch("UPDATE_AUTO_LOGOUT_STATE", true);
            }
        },
        handleScroll() {
            this.pageOptions.pageBodyScrollTop = window.scrollY;
        },
        onChangeMainPage() {
            // 페이지 변경시 메뉴명을 브라우저 제목으로 지정한다.
            //let menus = this.$store.getters.menus;
            let menus = this.readStorage("menus", []);
            if (!this.isEmpty(menus)) {
                let menu = menus.find((v) => v.path == this.$route.fullPath);

                // 메뉴가 없으면, 기본값으로 설정한다.
                if (this.isEmpty(menu)) {
                    this.initDocuemntTitle();
                    return;
                }

                // 메뉴가 있으면, 메인메뉴로 지정하고 브라우저 제목을 설정한다.
                this.$store.commit("UPDATE_MAIN_MENUS", menu);
                this.initDocuemntTitle(menu.title);
            }

            this.setThemeBackgroundColor();
        },
        initDocuemntTitle(title) {
            let brand = this.$store.getters.master.brand || "CxEMS v2.2"; // 아직 마스터정보가 없으면 기본값으로 대체한다.
            // let brand = 'CxEMS v2.1' || "CxEMS"; // 아직 마스터정보가 없으면 기본값으로 대체한다.

            let menuTitle = brand || "";
            if (!this.isEmpty(title)) menuTitle += "-" + this.$t(title);

            document.title = menuTitle;
            Vue.nextTick(() => {
                this.$forceUpdate();
            });
        },
        setThemeBackgroundColor() {
            this.contentBgColor.backgroundColor =
                window.location.hash == "#/visual/analysis/overview-dashboard"
                    ? global.xe.parseBool(localStorage.contentInverse)
                        ? require("./components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").dark
                              .backgroundColor
                        : require("./components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").light
                              .backgroundColor
                    : "#d9e0e7";
            this.contentFontColor.color =
                window.location.hash == "#/visual/analysis/overview-dashboard"
                    ? global.xe.parseBool(localStorage.contentInverse)
                        ? require("./components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").dark
                              .fontColor
                        : require("./components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").light
                              .fontColor
                    : "#333";
            //return this.isDashboard ? this.themeColor.backgroundColor : '#d9e0e7';
        },
    },
};
</script>
